import React from 'react';
import type { SpecCell } from '../../domain/property/detailV2';

/**
 * SpecBar — 히어로 아래 핵심 지표 4칸 (v2 목업 `.metrics`: 규모 · 전용 · 분양가 · 입주).
 * 값이 있는 칸만 렌더, 2칸 미만이면 렌더하지 않는다.
 * 분양가 칸 라벨은 가격 성격('원분양가' | '할인가').
 * v2h(2026-09-22): overlap=true 면 모바일에서 히어로 하단에 14px 겹침(목업 04).
 *   pcCells 는 lg+ 에서만 추가로 보이는 칸(목업 PC 04 의 '주차').
 */
export const SpecBar: React.FC<{ cells: SpecCell[]; pcCells?: SpecCell[]; overlap?: boolean }> = ({
  cells,
  pcCells = [],
  overlap = false,
}) => {
  if (cells.length < 2) return null;
  const all = [...cells.map((c) => ({ c, pcOnly: false })), ...pcCells.map((c) => ({ c, pcOnly: true }))];
  return (
    <div
      className={`relative z-[5] px-4 ${overlap ? '-mt-3.5 lg:mt-0 lg:pt-5' : 'pt-3'}`}
      data-testid="spec-bar"
    >
      <div
        className="grid gap-1 rounded-ca-3xl bg-frame px-2.5 py-3.5 text-center shadow-ca-card lg:![grid-template-columns:var(--spec-cols-lg)] lg:py-[18px]"
        style={
          {
            gridTemplateColumns: `repeat(${cells.length}, minmax(0, 1fr))`,
            '--spec-cols-lg': `repeat(${all.length}, minmax(0, 1fr))`,
          } as React.CSSProperties
        }
      >
        {all.map(({ c, pcOnly }) => (
          <div key={c.key} className={`min-w-0 ${pcOnly ? 'hidden lg:block' : ''}`}>
            <div className="text-[11px] text-muted">{c.label}</div>
            <div className={`num mt-0.5 truncate text-[15px] font-bold tracking-[-0.01em] ${c.accent ? 'text-accent' : 'text-ink'}`}>
              {c.value}
            </div>
            {c.sub && <div className="num truncate text-[11px] text-body">{c.sub}</div>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SpecBar;
